import React from "react";
import {
  Paper,
  Typography,
  IconButton,
  CircularProgress,
  Avatar,
  Fade,
  Stack,
} from "@mui/material";
import Icon from "@mui/material/Icon";

function getInitials(str = "") {
  return str
    .split(" ")
    .filter(Boolean)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export default function MonitoringPill({ name, loading, onStop }) {
  return (
    <Fade in>
      <Paper
        elevation={6}
        style={{
          position: "absolute",
          top: 8,
          left: "50%",
          transform: "translateX(-50%)",
          padding: "6px 12px",
          borderRadius: 9999,
          display: "flex",
          alignItems: "center",
          gap: 8,
          zIndex: 1200,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar style={{ width: 24, height: 24, fontSize: 12 }}>
            {getInitials(name)}
          </Avatar>

          <Typography variant="subtitle2" noWrap>
            Monitoring: <strong>{name}</strong>
          </Typography>

          <IconButton
            size="small"
            color="error"
            onClick={onStop}
            disabled={loading}
            style={{
              transition: "all 0.2s ease-in-out",
            }}
          >
            {loading ? (
              <CircularProgress size={16} />
            ) : (
              <Icon fontSize="small">highlight_off</Icon>
            )}
          </IconButton>
        </Stack>
      </Paper>
    </Fade>
  );
}
